class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    
    // Initialize favorite products event listeners
    this.initializeFavoriteProducts();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  // NEW METHOD: Initialize favorite products functionality
  initializeFavoriteProducts() {
    this.setupFavoriteProductListeners();
  }

  // NEW METHOD: Setup event listeners for favorite products
  setupFavoriteProductListeners() {
    // Remove any existing listeners first
    document.removeEventListener('click', this.handleFavoriteProductClick);
    
    // Add new event listener using event delegation
    document.addEventListener('click', this.handleFavoriteProductClick.bind(this));
  }

  // NEW METHOD: Handle favorite product button clicks
  handleFavoriteProductClick(event) {
    if (event.target.classList.contains('btn-add-to-cart')) {
      event.preventDefault();
      this.addFavoriteProductToCart(event.target);
    }
  }

  // NEW METHOD: Add favorite product to cart
  async addFavoriteProductToCart(button) {
    const variantId = button.dataset.variantId;
    const originalText = button.textContent;
    
    // Show loading state
button.classList.add('loading');
const iso = document.documentElement.lang || '{{ request.locale.iso_code | default: localization.language.iso_code | default: shop.locale }}';

if (iso.startsWith('da') || iso.startsWith('dk')) {
  button.textContent = 'Lægger til...';
} else if (iso.startsWith('sv')) {
  button.textContent = 'Lägger till...';
} else {
  button.textContent = 'Adding...';
}

button.disabled = true;
    
    try {
      // Add to cart using Fetch API
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId, 10),
            quantity: 1
          }]
        })
      });
      
      if (response.ok) {
        // Update the entire cart drawer to reflect changes
        await this.updateCartDrawer();
        
        // Show success message
        button.textContent = 'Tillagd!';
        setTimeout(() => {
          button.textContent = originalText;
          button.classList.remove('loading');
          button.disabled = false;
        }, 1500);
        
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      button.textContent = 'Error';
      setTimeout(() => {
        button.textContent = originalText;
        button.classList.remove('loading');
        button.disabled = false;
      }, 2000);
    }
  }

  // NEW METHOD: Update cart drawer after changes
  async updateCartDrawer() {
    try {
      // Fetch updated cart data
      const response = await fetch('/?section_id=cart-drawer');
      const text = await response.text();
      
      // Parse the response
      const html = new DOMParser().parseFromString(text, 'text/html');
      const newCartDrawer = html.querySelector('cart-drawer');
      
      if (newCartDrawer) {
        // Replace the current cart drawer with updated one
        this.innerHTML = newCartDrawer.innerHTML;
        
        // Re-initialize event listeners
        this.initializeFavoriteProducts();
        
        // Update cart count in header
        this.updateCartCount();
      }
    } catch (error) {
      console.error('Error updating cart drawer:', error);
      // Fallback: reload the page if update fails
      window.location.reload();
    }
  }

  // NEW METHOD: Update cart count in header
  updateCartCount() {
    // Update any cart count elements
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCounts = document.querySelectorAll('.cart-count-bubble, .cart-count');
        cartCounts.forEach(element => {
          element.textContent = cart.item_count;
        });
      })
      .catch(error => console.error('Error updating cart count:', error));
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    
    // Re-initialize favorite products when opening drawer
    this.initializeFavoriteProducts();
    
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // Re-initialize favorite products after rendering
    setTimeout(() => {
      this.initializeFavoriteProducts();
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);